<template>
  <div>
    <top-nav :page_title="page_title"></top-nav>
    <br>
    <mdb-card>
      <!-- FLASH MESSAGES -->
      <FlashMessage :position="'right bottom'"></FlashMessage>
      <div class="header pt-3 blue-gradient">
        <mdb-card-header :data-background-color="dataBackgroundColor">
          <mdb-row class="d-flex justify-content-center">
            <h4 class="white-text mb-3 pt-3 title">Complete your profile</h4>
          </mdb-row>
        </mdb-card-header>
      </div>

      <mdb-card-body class="mx-4 mt-4">
        <form @submit.prevent="onSubmit">
          <div>
            <!--FIRST NAME-->
            <b-form-group :class="{ 'form-group--error': $v.user.firstName.$error }">
              <mdb-input id="fName" v-model.trim="$v.user.firstName.$model"
                         icon="user" label="First name" type="text"/>
              <div v-if="$v.user.firstName.$dirty">
                <div v-if="!$v.user.firstName.required" class="error">Field is
                  required
                </div>
                <div v-if="!$v.user.firstName.minLength" class="error">Name must
                  have at least {{ $v.user.firstName.$params.minLength.min }}
                  letters.
                </div>
              </div>
            </b-form-group>

            <!--LAST NAME-->
            <b-form-group :class="{ 'form-group--error': $v.user.lastName.$error }">
              <mdb-input id="lName" v-model.trim="$v.user.lastName.$model"
                         icon="user" label="Last name" type="text"/>
              <div v-if="$v.user.lastName.$dirty">
                <div v-if="!$v.user.lastName.required" class="error">Field is
                  required
                </div>
                <div v-if="!$v.user.lastName.minLength" class="error">Name must have
                  at least {{ $v.user.lastName.$params.minLength.min }} letters.
                </div>
              </div>
            </b-form-group>

            <!-- User email and role drop down -->
            <user-email-role-component :user="user"></user-email-role-component>

            <!-- PASSWORD-->
            <div v-if="email_confirmed === false">
              <Password_ConfirmPasswordComponent></Password_ConfirmPasswordComponent>
            </div>
          </div>

          <mdb-row class="d-flex align-items-center mb-4 mt-5">
            <mdb-col class="d-flex align-items-start" md="5">
              <a href="/user">
                <button class="btn btn-outline-info btn-rounded" type="button">
                  <i class="fas fa-arrow-left"></i>
                  Back
                </button>
              </a>
            </mdb-col>
            <mdb-col class="d-flex justify-content-end" md="7">
              <div class="text-center">
                <button class="btn btn-outline-info btn-rounded" type="button"
                        @click="onSubmit"> Update
                  <i class="fas fa-pencil-alt"></i></button>
              </div>

              <!-- DEACTIVATE USER COMPONENT -->
              <deactivate-user :user="user"></deactivate-user>
            </mdb-col>
          </mdb-row>
        </form>
      </mdb-card-body>
    </mdb-card>
  </div>
</template>
<script>
import {mdbCard, mdbCardBody, mdbCardHeader, mdbCol, mdbInput, mdbRow} from "mdbvue";
import TopNav from "@/components/TopNav";
import {
  getStoredUserDetails, getUserEmail, handleError, logOutUser,
  secureStoreGetAuthString, selectDropDownItemForUpdate, showFlashMessage, startLoader, viewPassword
} from '@/utils/util_functions';
import {email, minLength, required} from "vuelidate/lib/validators";
import {user_resource} from "@/utils/api_paths";
import axios from "axios";
import Password_ConfirmPasswordComponent from "@/components/Password_ConfrimPasswordComponent";
import EventBus from "@/components/EventBus";
import DeactivateUser from "@/components/in_form/DeactivateUserComponent";
import UserEmailRoleComponent from "@/components/in_form/UserEmailRoleComponent";

export default {
  name: "edit-profile-form",
  props: {
    dataBackgroundColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      page_title: "Edit Profile",
      user: {
        firstName: '',
        lastName: '',
        role: '',
        email: '',
        password: ''
      },
      email_confirmed: true
    };
  },
  validations: {
    user: {
      firstName: {required, minLength: minLength(3)},
      lastName: {required, minLength: minLength(3)},
      email: {required, email},
    }
  },

  mounted() {
    EventBus.$on('setPwd', payload=>{
      this.user.password = payload
    })
  },
  methods: {
    viewPassword, selectDropDownItemForUpdate,
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.updateUser(this.user);
    },
    onLoadPage() {
      this.fillUserFormForUpdate()
    },

    // set user details in form
    fillUserFormForUpdate: function () {
      let userForUpdate = getStoredUserDetails()
      this.user.firstName = userForUpdate['first_name']
      this.user.lastName = userForUpdate['last_name']
      this.user.role = userForUpdate['role']
      this.email_confirmed = userForUpdate['email_confirmed']
      this.user.email = getUserEmail()
    },

    updateUser: function (user) {
      let loader = startLoader(this)

      axios.put(user_resource, {
        first_name: user.firstName,
        last_name: user.lastName,
        email: user.email,
        role: user.role,
        password: user.password,
      }, {
        headers:
            {
              Authorization: secureStoreGetAuthString()
            }
      })
          .then((response) => {
            // redirect after successful signUp
            if (response.status === 202) {
              setTimeout(() => {
                loader.hide()
                showFlashMessage(this, 'success', 'User Updated', 'Please log-in for changes to take effect ');
              }, 1500)
              logOutUser(this)
            }
          })
          .catch((error) => {
            handleError(this, error, loader)
          })

    },
  },
  components: {
    UserEmailRoleComponent, DeactivateUser, Password_ConfirmPasswordComponent, mdbCard, mdbCardHeader,
    mdbCardBody, mdbRow, mdbCol, mdbInput, TopNav},
  created() {
    this.onLoadPage();
    this.$log.info('user', this.user)
  }
};
</script>
